import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const CopyIcon = (p: IconProps) => <Icon {...p}><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15V4a2 2 0 0 1 2-2h11" /></Icon>
